export default __webpack_public_path__ + "static/media/cover.518b5b3b.png";